import React, { useEffect, useState } from 'react';
import DetailComp from 'components/Detail';
import LoaderCP from 'components/loader';
import NotFound from 'components/notFound';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getDetail } from '../../slices/detailSlice';

const DetailContainer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { detail, status } = useSelector((state) => state.detail);
  const { disableButton } = useSelector((state) => state.countDown);
  const { offerAgain } = useSelector((state) => state.offer);
  const { statusExtendedAuction, closeAuction } = useSelector((state) => state.offersSocket);

  const [reload, setReload] = useState(false);
  if (disableButton === true) {
    setInterval(() => {
      setReload(true);
    }, 6000);
  }

  useEffect(() => {
    dispatch(getDetail(id));
  }, [offerAgain, statusExtendedAuction, closeAuction, reload]);

  return (
    <div>
      {status === 'loading' && <LoaderCP />}
      {status === 'failed' && <NotFound />}
      {status === 'success' ? <DetailComp detail={detail} /> : '' }
    </div>
  );
};

export default DetailContainer;
